<aaos-spinner [isLoading]="loading"></aaos-spinner>